import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';
import WhatIsOpenInnovationModel from './what-is-open-innovation.model.js';

class WhatIsOpenInnovationService {
	getPageData(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/WhatIsOpenInnovation?lang=${lang}`,
			)
			.then(res => new WhatIsOpenInnovationModel(res.data))
			.catch(logError);
	}
}
export default new WhatIsOpenInnovationService();
